import React, { useEffect, useState } from "react";
import { useCaptureEvent } from "../../hooks/useCaptureEvent";

export default function Persona({ contact_id, activeWorkspace, userId }) {
  const captureEvent = useCaptureEvent();
  const [requested, setRequested] = useState(false);
  const handleRequested = (click = true) => {
    if (click) {
      localStorage.setItem(`${userId}_${contact_id}_${activeWorkspace?.id}_persona`, "true");
      setRequested(true);
    } else {
      const localData = localStorage.getItem(`${userId}_${contact_id}_${activeWorkspace?.id}_persona`);
      localData === "true" ? setRequested(true) : setRequested(false);
    }
  };
  useEffect(() => {
    handleRequested(false);
  }, []);

  return (
    <div className="border   rounded-[14px] overflow-hidden border-input  bg-background relative">
      <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
        <div className="inline-flex items-center">
          <span className="text-[16px] text-text-700 mr-2 font-semibold leading-none ">Persona</span>
          <span className="inline-block text-[12px] text-text-700 border border-input px-2 py-0.5 rounded-[20px]">
            Beta
          </span>
        </div>
        {/* <span className="text-text-700">Score</span> */}
      </div>
      <p className="text-sm mb-5 px-4">
        Personas help identify if a person’s profile matches a relevant persona for your business. This can
        include <span className="text-purple-700">Economic Buyers</span>,{" "}
        <span className="text-success-700">Ideal Users</span> or any other persona based on your needs.
      </p>
      <div className="px-4 mb-4 space-y-4">
        <div className="flex justify-between">
          <span className="inline-block text-[12px] bg-purple-50 text-purple-700 border border-purple-200 px-2 py-1 rounded-3xl">
            Economic Buyer
          </span>
          <span className="inline-block  text-[12px] bg-success-600 text-white border border-input px-2 py-1 rounded-lg">
            98
          </span>
        </div>
        <div className="flex justify-between">
          <span className="inline-block text-[12px] bg-success-50 text-success-700 border border-success-200 px-2 py-1 rounded-3xl">
            Ideal user
          </span>
          <span className="inline-block  text-[12px] bg-warning-500 text-white border border-input px-2 py-1 rounded-lg">
            72
          </span>
        </div>
        <button
          onClick={() => {
            if (!requested) {
              handleRequested(true);
            }
            captureEvent("EXP_Persona_GetAccessBtn");
          }}
          disabled={requested}
          className="flex w-full items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background border-brand-300 text-brand-700 px-4 py-2 justify-center h-9 rounded-[8px] font-semibold pr-2.5"
        >
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mr-1"
          >
            <path
              d="M14.1663 9.98405V7.48405C14.1663 5.18286 12.3009 3.31738 9.99967 3.31738C7.69849 3.31738 5.83301 5.18286 5.83301 7.48405V9.98405M7.33301 18.3174H12.6663C14.0665 18.3174 14.7665 18.3174 15.3013 18.0449C15.7717 17.8052 16.1542 17.4228 16.3939 16.9524C16.6663 16.4176 16.6663 15.7175 16.6663 14.3174V13.984C16.6663 12.5839 16.6663 11.8839 16.3939 11.3491C16.1542 10.8787 15.7717 10.4962 15.3013 10.2565C14.7665 9.98405 14.0665 9.98405 12.6663 9.98405H7.33301C5.93288 9.98405 5.23281 9.98405 4.69803 10.2565C4.22763 10.4962 3.84517 10.8787 3.60549 11.3491C3.33301 11.8839 3.33301 12.5839 3.33301 13.984V14.3174C3.33301 15.7175 3.33301 16.4176 3.60549 16.9524C3.84517 17.4228 4.22763 17.8052 4.69803 18.0449C5.23281 18.3174 5.93288 18.3174 7.33301 18.3174Z"
              stroke="var(--brand-700)"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>{requested ? "Requested" : "Get Access"}</span>
        </button>
      </div>
    </div>
  );
}
